import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  staticText: any = {
    agentIntegration: {},
  };

  constructor(
    private sharedService: SharedService
  ) {
  }

  fetchStaticText(): Promise<void> {
    return new Promise((resolve, reject) => {
      let langCode = this.getLanguage;
      if (langCode === 'jp') langCode = 'ja';
      else if (langCode === 'hrv') langCode = 'hr';
      else if (langCode === 'swv') langCode = 'sv';

      const apiUrl = `${environment.cdnUrl}/lang/${langCode}`;

      this.sharedService.loader('start');

      this.getTexts(`${apiUrl}-agent-integration`)
        .then((agentIntegration) => {
          try {
            this.staticText.agentIntegration = this.parseLang(String(agentIntegration));
            resolve();
          } catch (parseError) {
            console.error('Error parsing static text:', parseError);
            reject(parseError);
          }
        })
        .catch((error) => {
          console.error('Error fetching static text:', error);
          reject(error);
        })
        .finally(() => this.sharedService.loader('stop'));
    });
  }

  parseLang(data: string) {
    const brand = sessionStorage.getItem('brand');
    try {
      const changedBrandName = data.replace('${bpBrandName}', String(brand));
      return JSON.parse(changedBrandName);
    } catch (error) {
      return {};
    }
  }

  getTexts(url: string) {
    return fetch(url)
      .then((res) => res.text())
      .catch(console.log);
  }

  getStaticText() {
    return this.staticText;
  }

  get getLanguage() {
    try {
      const storedLang = localStorage.getItem('language');
      const parsedLang = storedLang ? JSON.parse(storedLang) : null;
      return parsedLang?.value || 'en';
    } catch (error) {
      return 'en';
    }
  }
}
